import { createMuiTheme } from '@material-ui/core/styles'

// const fontWeightBold = 700
// const fontWeightSemiBold = 500
const fontWeightMedium = 500
const fontWeightRegular = 400
// const fontWeightThin = 300

// const spacingUnit = 8
// export const spacing = {
//   unit: spacingUnit,
//   xxxl: spacingUnit * 10,
//   xxl: spacingUnit * 8,
//   xl: spacingUnit * 6,
//   lg: spacingUnit * 4,
//   mdlg: spacingUnit * 3,
//   md: spacingUnit * 2,
//   sm: spacingUnit,
//   xs: spacingUnit / 2,
//   dashboardPage: spacingUnit * 6,
// }
export const spacingUnit = 8

const spacing = multiplier => multiplier * spacingUnit

const typography = {
  field: {
    title: {
      fontSize: '1rem',
      fontFamily: 'Roboto',
      letterSpacing: 0,
      color: '#949494',
      margin: '30px 0 10px',
    },
  },
}

const breakpointValues = {
  xs: 0,
  sm: 600,
  md: 1024,
  lg: 1280,
  xl: 1440,
}

const components = {
  pill: {
    height: 24,
    color: '#fff',
    borderRadius: 5,
    lineHeight: '16px',
    padding: '4px 16px',
    transition: 'background-color .3s ease',
  },
  accountPage: {
    height: '100%',
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    justifyContent: 'center',
    transition: 'transform .3s ease',
  },
  backButton: {
    position: 'absolute',
    top: 80,
    left: 0,
  },
  smallSubmitButton: {
    width: 170,
    height: 50,
  },
  popover: {
    width: 400,
    textAlign: 'center',
  },
  toast: {
    width: '100%',
    height: '100%',
    display: 'flex',
    padding: '0px 24px',
    alignItems: 'center',
    maxWidth: 1150,
    margin: '0 auto',
    justifyContent: 'space-between',
  },
}

const content = {
  large: {
    width: '100%',
    maxWidth: 1280,
    margin: '0 auto',
  },
  dialog: {
    width: '100%',
    maxWidth: 756,
    margin: '0 auto',
  },
}

export const animation = {
  fadeIn: {
    animation: 'fadeIn .2s ease',
  },
}

export const palette = {
  primary: {
    main: '#F37021',
    dark: '#DB5E13',
    light: '#F3702150',
  },
  secondary: {
    main: '#FFAD7B',
  },
  tertiary: {
    light: '#DFE9F8',
    main: '#419EF6',
    dark: '#2A7CC9',
    toast: '#245889',
  },
  black: '#323232',
  white: '#ffffff',
  background: {
    dark: '#ccc',
    medium: '#E1E1E1',
    light: '#F5F7FA',
    grey: '#F8F8F8',
    header: '#FBFBFB',
    default: '#fff',
  },
  disabled: {
    main: '#AAAAAA',
    trap: '#B3B3B3',
    light: '#EEEEEE',
  },
  success: {
    dark: '#01996f',
    main: '#04CB94',
    light: '#CFFFD2',
  },
  error: {
    dark: '#c1173c',
    main: '#FF2151',
    light: '#FBE3EE',
  },
  text: {
    primary: '#000000',
    secondary: '#949494',
  },
  accent: {
    main: '#001224',
  },
  divider: '#ECECEC',
}

const theme = createMuiTheme({
  palette,
  content,
  spacing,
  animation,
  typography,
  components,
  breakpoints: { values: breakpointValues },
  status: {
    danger: 'orange',
  },
  props: {
    MuiWithWidth: {
      initialWidth: 'xs',
    },
  },
})

const appFontFamily = "'Lato', 'Roboto', 'sans-serif'"

// We can only use typography function such as pxToRem after the createMuiTheme
theme.typography = {
  ...theme.typography,
  fontFamily: appFontFamily,
  h1: {
    letterSpacing: 0,
    fontWeight: fontWeightRegular,
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(41),
  },
  h2: {
    fontSize: theme.typography.pxToRem(32),
    lineHeight: theme.typography.pxToRem(38),
    fontWeight: fontWeightRegular,
  },
  subheading: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(38),
    fontWeight: fontWeightRegular,
    textTransform: 'uppercase',
    color: palette.text.primary,
  },
  caption: {
    fontSize: theme.typography.pxToRem(11),
    lineHeight: theme.typography.pxToRem(16),
    fontWeight: fontWeightRegular,
    textTransform: 'uppercase',
    color: palette.text.secondary,
  },
  body1: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    fontWeight: fontWeightRegular,
    fontFamily: appFontFamily,
  },
  body2: {
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(18),
    fontWeight: fontWeightRegular,
    fontFamily: appFontFamily,
  },
  h3: {
    fontSize: theme.typography.pxToRem(24),
    lineHeight: theme.typography.pxToRem(28),
    fontWeight: fontWeightRegular,
    color: palette.text.primary,
  },
  h4: {
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(22),
    fontWeight: fontWeightRegular,
    color: palette.text.primary,
  },
  subtitle1: {
    fontSize: theme.typography.pxToRem(28),
    lineHeight: theme.typography.pxToRem(40),
    fontWeight: fontWeightRegular,
    color: palette.text.primary,
  },
  tag: {
    fontSize: theme.typography.pxToRem(10),
    textTransform: 'uppercase',
    fontWeight: fontWeightRegular,
    color: palette.text.primary,
  },
}

// Overrides are assigned here so we can use theme.breakpoints
theme.overrides = {
  MuiHeader: {
    root: {
      paddingBottom: 0,
    },
  },
  MuiCard: {
    root: {
      borderRadius: 0,
      border: `1px solid ${palette.divider}`,
      boxShadow: 'none',
    },
  },
  MuiChip: {
    root: {
      marginRight: theme.spacing(1),
      color: palette.primary.main,
      height: 28,
      backgroundColor: 'transparent',
      border: `1px solid ${palette.primary.main}`,
    },
  },
  MuiCollapse: {
    entered: {
      height: 'auto',
      overflow: 'visible',
    },
  },
  Button: {
    raised: {
      textTransform: 'none',
      borderRadius: 50,
      fontSize: '1rem',
      fontWeight: fontWeightRegular,
      boxShadow:
        '0px 1px 5px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    },
  },
  MuiButtonBase: {
    root: {
      fontSize: 14,
      textTransform: 'none',
    },
  },
  MuiList: {
    root: {
      padding: 0,
    },
    padding: {
      padding: 0,
    },
  },
  Link: {
    link: {
      fontStyle: 'normal',
      color: palette.primary.main,
    },
  },
  MuiDialog: {
    paper: {
      borderRadius: 10,
      minWidth: '60vw',
    },
  },
  MuiSelect: {
    icon: {
      color: theme.palette.primary.main,
    },
    select: {},
  },
  MuiPaper: {
    root: {
      marginTop: 45,
      boxShadow: '0px 5px 10px rgba(0,0,0,0.2) !important',
    },
  },
  MuiMenuItem: {
    root: {
      fontSize: theme.typography.pxToRem(14),
      color: theme.palette.text.main,
      padding: '6px 24px',
      minWidth: 100,
      // Hide empty label value
      "&[data-value='']": {
        display: 'none',
      },
    },
  },
  MuiTab: {
    root: {
      textTransform: 'none',
      minHeight: 56,
      [theme.breakpoints.up('xs')]: {
        minWidth: 0,
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
      },
      '&:first-of-type': {
        marginLeft: 0,
      },
    },
    label: {
      [theme.breakpoints.up('xs')]: {
        fontSize: theme.typography.pxToRem(18),
        fontWeight: fontWeightRegular,
      },
    },
    textColorPrimary: {
      color: palette.text.primary,
    },
    labelContainer: {
      [theme.breakpoints.up('xs')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  MuiTableCell: {
    head: {
      color: palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      fontWeight: fontWeightMedium,
      padding: '10px',
    },
    body: {
      color: palette.text.primary,
      fontSize: theme.typography.pxToRem(15),
      fontWeight: fontWeightRegular,
      padding: '10px',
    },
  },
  MuiTableHead: {
    root: {
      background: theme.palette.background.grey,
    },
  },
  MuiFormHelperText: {
    root: {
      position: 'absolute',
      bottom: -15,
      left: 0,
    },
  },
}

export default theme



// WEBPACK FOOTER //
// ./src/styles/theme.js